import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from 'i2g-ng-utils';

export const RATING_SCHEMA = Object.freeze({
  ID: null,
  CATEGORY: null,
  QUESTION: null,
});
const RECORD = generateSchema(RATING_SCHEMA);
const KEYS: any = generateKeys(RATING_SCHEMA);

export class Rating extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get category(): string {
    return this.get(KEYS.CATEGORY);
  }

  get question(): string {
    return this.get(KEYS.QUESTION);
  }
}
